import React from 'react'

import translations from '@/translations/home'
import FaqSection from '@/components/blocks/FaqSection'
import { Layout } from '@/components/layout'
import BottomCTA from '@/components/sections/home/BottomCTA/BottomCTA'
import Hero from '@/components/sections/home/Hero/Hero'
import HowItWorks from '@/components/sections/home/HowItWorks/HowItWorks'
import LogoMarquee from '@/components/sections/home/LogoMarquee/LogoMarquee'
import Testimonials from '@/components/sections/home/Testimonials/Testimonials'

import styles from './index.module.scss'

export default function Home() {
  return (
    <div className={styles.container}>
      <Layout.Content>
        <Hero t={translations.hero} />
        <LogoMarquee t={translations.marquee} />
        <HowItWorks t={translations.howItWorks} />
        <Testimonials t={translations.testimonials} />
        <FaqSection faqs={['whatItDoes', 'taxTime', 'rentalHosts', 'gettingDocsIn', 'security']} pageId="home" />
        <BottomCTA t={translations.bottomCta} />
      </Layout.Content>
    </div>
  )
}

Home.layoutProps = { pageId: 'home' }
